import {MinifiedArgument} from '../core/models/minified-argument.model';
import { isFunction } from '../helpers/type-utils';
import {MinifiedSelection} from '../widgets/minified-selections/models/minified-selection-model';
import {QueryFilterParameter} from './../widgets/filters/models/query-filter-parameter.model';

export class SelectStatementOptions {
	
	/**
	 * MinifiedArguments
	 */
	private _minifiedArguments?: MinifiedArgument[] | (() => Promise<MinifiedArgument[]>);
	public get minifiedArguments(): Promise<MinifiedArgument[]> {
		return isFunction(this._minifiedArguments) ? this._minifiedArguments() : (new Promise<any>((resolve) => {resolve(this._minifiedArguments)}));
	}

	/**
	 * MinifiedSelections
	 */
	private _minifiedSelections?: MinifiedSelection[] | (() => Promise<MinifiedSelection[]>);
	public get minifiedSelections(): Promise<MinifiedSelection[]> {
		return isFunction(this._minifiedSelections) ? this._minifiedSelections() : (new Promise<any>((resolve) => {resolve(this._minifiedSelections)}));
	}
	
	/**
	 * Filters
	 */
	private _filters?: QueryFilterParameter[] | (() => Promise<QueryFilterParameter[]>);
	public get filters(): Promise<QueryFilterParameter[]> {
		return isFunction(this._filters) ? this._filters() : (new Promise<any>((resolve) => {resolve(this._filters)}));
	}

	/**
	 * BaseSelectStatementId
	 */
	private _baseSelectStatementId?: number | (() => Promise<number>);
	public get baseSelectStatementId(): Promise<number> {
		return isFunction(this._baseSelectStatementId) ? this._baseSelectStatementId() : (new Promise<any>((resolve) => {resolve(this._baseSelectStatementId)}));
	}

	/**
	 * SelectionSetId
	 */
	private _selectionSetId?: number | (() => Promise<number>);
	public get selectionSetId(): Promise<number> {
		return isFunction(this._selectionSetId) ? this._selectionSetId() : (new Promise<any>((resolve) => {resolve(this._selectionSetId)}));
	}

	/**
	 * SettingsGroupId
	 */
	private _settingsGroupId?: number | (() => Promise<number>);
	public get settingsGroupId(): Promise<number> {
		return isFunction(this._settingsGroupId) ? this._settingsGroupId() : (new Promise<any>((resolve) => {resolve(this._settingsGroupId)}));
	}

	/**
	 * TopCount
	 */
	private _topCount?: number | (() => Promise<number>);
	public get topCount(): Promise<number> {
		return isFunction(this._topCount) ? this._topCount() : (new Promise<any>((resolve) => {resolve(this._topCount)}));
	}

	/**
	 * PeriodType
	 */
	private _periodType?: string | (() => Promise<string>);
	public get periodType(): Promise<string> {
		return isFunction(this._periodType) ? this._periodType() : (new Promise<any>((resolve) => {resolve(this._periodType)}));
	}

	/**
	 *
	 */
	constructor(
		parameters?: {
			minifiedArguments?: MinifiedArgument[] | (() => Promise<MinifiedArgument[]>),
			minifiedSelections?: MinifiedSelection[] | (() => Promise<MinifiedSelection[]>),
			filters?: QueryFilterParameter[] | (() => Promise<QueryFilterParameter[]>),
			baseSelectStatementId?: number | (() => Promise<number>),
			selectionSetId?: number | (() => Promise<number>),
			settingsGroupId?: number | (() => Promise<number>),
			topCount?: number | (() => Promise<number>),
			periodType?: string | (() => Promise<string>)

			// minifiedArguments?: MinifiedArgument[],
			// minifiedSelections?: MinifiedSelection[],
			// filters?: QueryFilterParameter[],
			// baseSelectStatementId?: number,
			// selectionSetId?: number,
			// settingsGroupId?: number,
			// topCount?: number,
			// periodType?: string
		}
	) {
		this._minifiedArguments =		parameters?.minifiedArguments;
		this._minifiedSelections =		parameters?.minifiedSelections;
		this._filters =					parameters?.filters;
		this._baseSelectStatementId =	parameters?.baseSelectStatementId;
		this._selectionSetId =			parameters?.selectionSetId;
		this._settingsGroupId =			parameters?.settingsGroupId;
		this._topCount =				parameters?.topCount;
		this._periodType =				parameters?.periodType;
	}
}
